import { Formik, Form } from 'formik';
import { useCallback } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaSpotify } from 'react-icons/fa';
import { DefaultTheme, useTheme } from 'styled-components';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { FiLock } from 'react-icons/fi';
import { HiCheck } from 'react-icons/hi';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { ValidationPassword } from '../../../layouts/auth/styles';
import { useQuery } from '../../../utils/useQuery';
import api from '../../../services/api';

const schema = yup.object({
  password: yup
    .string()
    .required('Digite sua senha')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])[A-Za-z\d`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]{8,}$/,
      'Coloque todas as restrições de senha',
    ),
});

interface SubmitProps {
  password: string;
}

export const RecoveryPassword = () => {
  const history = useHistory();
  const query = useQuery();
  const tokenPassword = query.get('token');
  const emailQuery = query.get('email');
  const theme: DefaultTheme = useTheme();
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState<
    Array<'UPPERCASE' | 'LOWERCASE' | 'MIN' | 'SPECIAL' | 'NUMBER'>
  >([]);

  const handleSubmit = useCallback(
    async ({ password }: SubmitProps) => {
      try {
        setLoading(true);
        if (!tokenPassword || !emailQuery) {
          toast.error('Token inválido');
          return;
        }
        await api.post('auth/password_change', {
          tokenPassword,
          email: emailQuery,
          password,
        });
        toast.success('Senha salva com sucesso, faça seu login');
        history.push('/');
      } catch (err: any) {
        if (err.response.data.message) {
          toast.error(err.response.data.message);
          return;
        }
        toast.error('Erro ao realizar login');
      } finally {
        setLoading(false);
      }
    },
    [history],
  );

  const handleValidationPassword = (e: string) => {
    if (e.length >= 8) {
      setValidation(old => (old.indexOf('MIN') >= 0 ? old : [...old, 'MIN']));
    } else {
      setValidation(old => {
        if (old.indexOf('MIN') >= 0) {
          return old.filter(item => item !== 'MIN');
        }
        return old;
      });
    }

    if (/\d/.test(e)) {
      setValidation(old =>
        old.indexOf('NUMBER') >= 0 ? old : [...old, 'NUMBER'],
      );
    } else {
      setValidation(old => {
        if (old.indexOf('NUMBER') >= 0) {
          return old.filter(item => item !== 'NUMBER');
        }
        return old;
      });
    }

    if (/[A-Z]+/.test(e)) {
      setValidation(old =>
        old.indexOf('UPPERCASE') >= 0 ? old : [...old, 'UPPERCASE'],
      );
    } else {
      setValidation(old => {
        if (old.indexOf('UPPERCASE') >= 0) {
          return old.filter(item => item !== 'UPPERCASE');
        }
        return old;
      });
    }

    if (/[a-z]/.test(e)) {
      setValidation(old =>
        old.indexOf('LOWERCASE') >= 0 ? old : [...old, 'LOWERCASE'],
      );
    } else {
      setValidation(old => {
        if (old.indexOf('LOWERCASE') >= 0) {
          return old.filter(item => item !== 'LOWERCASE');
        }
        return old;
      });
    }

    if (/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(e)) {
      setValidation(old =>
        old.indexOf('SPECIAL') >= 0 ? old : [...old, 'SPECIAL'],
      );
    } else {
      setValidation(old => {
        if (old.indexOf('SPECIAL') >= 0) {
          return old.filter(item => item !== 'SPECIAL');
        }
        return old;
      });
    }
  };

  return (
    <Formik
      initialValues={{ password: '' }}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <Form>
        <h5 className="text-center">
          <FaSpotify
            size={65}
            color={theme.colors.secondary}
            className="mr-2"
          />
        </h5>
        <h4 className="text-center mt-3 mb-3">Recuperação de senha</h4>
        <h6>Lorem ipsum dolor sit amet consectetur adipiscing elit</h6>

        <Input
          type="password"
          name="password"
          placeholder="Nova senha"
          onChangeCapture={(e: React.ChangeEvent<any>) =>
            handleValidationPassword(e.target.value)
          }
          icon={FiLock}
        />

        <ul className="d-flex align-items-center justify-content-start flex-wrap mt-2">
          <ValidationPassword check={validation.indexOf('SPECIAL') >= 0}>
            <HiCheck />
            <span>1 caracter especial</span>
          </ValidationPassword>
          <ValidationPassword check={validation.indexOf('MIN') >= 0}>
            <HiCheck />
            <span>8 ou mais caracteres</span>
          </ValidationPassword>
          <ValidationPassword check={validation.indexOf('NUMBER') >= 0}>
            <HiCheck />
            <span>1 número</span>
          </ValidationPassword>
          <ValidationPassword check={validation.indexOf('UPPERCASE') >= 0}>
            <HiCheck />
            <span>1 letra maiúscula</span>
          </ValidationPassword>
          <ValidationPassword check={validation.indexOf('LOWERCASE') >= 0}>
            <HiCheck />
            <span>1 letra minúscula</span>
          </ValidationPassword>
        </ul>

        <Button
          className="mt-4"
          type="submit"
          background={theme.colors.secondary}
          loading={loading || undefined}
          color="#fff"
        >
          Salvar senha
        </Button>
      </Form>
    </Formik>
  );
};
